module.exports = __webpack_public_path__ + "img/num_10.35aaae56.png";